
import React from "react";
import { useNavigate } from "react-router-dom";
import { Building } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CompanyForm, { CompanyFormValues } from "@/components/CompanyForm";
import { useCompanyStore } from "@/lib/store";

const AddCompany = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const addCompany = useCompanyStore((state) => state.addCompany);
  
  const handleSubmit = (data: CompanyFormValues) => {
    // Create a new company with the form data
    const logoPreview = data.logo instanceof File ? 
      URL.createObjectURL(data.logo) : null;
      
    addCompany({
      name: data.name,
      locations: [data.location], // Convert to array as per type
      bio: data.bio,
      staffSize: data.staffSize,
      logo: logoPreview || undefined, // Store the preview URL
      website: data.website,
      twitterUrl: data.twitterUrl,
      instagramUrl: data.instagramUrl,
      linkedinUrl: data.linkedinUrl,
    });
    
    console.log("New company created and saved to store");
    
    // Show a success message
    toast({
      title: "Company added",
      description: `${data.name} has been successfully added`,
    });
    
    // Navigate back to dashboard
    navigate("/admin/dashboard");
  };

  const handleCancel = () => {
    navigate("/admin/dashboard");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 pt-24 px-6 pb-16">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <Building className="w-6 h-6 text-redflags-red" />
            <h1 className="text-2xl font-bold text-redflags-dark">Add New Company</h1>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm border p-6 mb-8">
            <CompanyForm 
              onSubmit={handleSubmit}
              onCancel={handleCancel}
            />
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AddCompany;
